export enum ImageCompressionType {
  None = 1,
  ResizeToFit,
}
